/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Invite_Missing_TokenInputs */

const cs_portal_invite_missing_token = /** @type {(inputs: Portal_Invite_Missing_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz pozvánky chybí nebo je neplatný.`)
};

const en_portal_invite_missing_token = /** @type {(inputs: Portal_Invite_Missing_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link is missing or invalid.`)
};

/**
* | output |
* | --- |
* | "Invite link is missing or invalid." |
*
* @param {Portal_Invite_Missing_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_invite_missing_token = /** @type {((inputs?: Portal_Invite_Missing_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Invite_Missing_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_invite_missing_token(inputs)
	return cs_portal_invite_missing_token(inputs)
});